// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe8775b2","239":"1bdff159","732":"b0bd6883"}[chunkId] + ".chunk.js";
};